"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _GenerateQrcode = _interopRequireDefault(require("../GenerateQrcode"));
var _teaComponent = require("@tencent/tea-component");
var _excluded = ["className", "style", "size", "caption", "visible", "homeInfos", "homeCode", "onCopyClick", "children", "v2"];
var ShareActiveHomeModal = function ShareActiveHomeModal(props) {
  var className = props.className,
    style = props.style,
    size = props.size,
    caption = props.caption,
    visible = props.visible,
    homeInfos = props.homeInfos,
    homeCode = props.homeCode,
    onCopyClick = props.onCopyClick,
    children = props.children,
    v2 = props.v2,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('share-active-home-modal');
  var classes = (0, _classnames.default)(prefixCls, className, {
    v2: v2
  });
  return /*#__PURE__*/_react.default.createElement(_teaComponent.Modal, (0, _extends2.default)({
    size: size,
    caption: caption,
    visible: visible,
    className: classes
  }, extraProps), /*#__PURE__*/_react.default.createElement(_teaComponent.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "section-obj"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "section-code"
  }, /*#__PURE__*/_react.default.createElement(_GenerateQrcode.default, homeCode)), /*#__PURE__*/_react.default.createElement("div", {
    className: "section-obj__desc"
  }, homeCode === null || homeCode === void 0 ? void 0 : homeCode.desc)), /*#__PURE__*/_react.default.createElement("div", {
    className: "section-con"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "section-con__hd"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "section-con__title"
  }, "\u590D\u5236\u7684\u94FE\u63A5\u5185\u5BB9\u5982\u4E0B\uFF1A"), /*#__PURE__*/_react.default.createElement("div", {
    className: "section-con__opers"
  }, /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    type: "primary",
    className: "size-xs",
    onClick: function onClick() {
      onCopyClick ? onCopyClick() : undefined;
    }
  }, "\u590D\u5236\u94FE\u63A5"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "section-con__infos"
  }, homeInfos)), !v2 && /*#__PURE__*/_react.default.createElement("div", {
    className: "section-bg"
  })));
};
var _default = ShareActiveHomeModal;
exports.default = _default;